import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
  selector: 'app-admin-form',
  templateUrl: './admin-form.component.html',
  styleUrls: ['./admin-form.component.scss'],
  providers: [MessageService]
})
export class AdminFormComponent implements OnInit {
  public usuarioForm: FormGroup;

  constructor(private fb: FormBuilder, private usuarioService: UsuarioService, private messageService: MessageService) {

    this.usuarioForm = this.fb.group({
      email: new FormControl<string>('', [Validators.required, Validators.email]),
      contrasena: new FormControl<string>('', [Validators.required]),
      contrasena_confirmation: new FormControl<string>('', [Validators.required]),
      nombre: new FormControl<string>('', Validators.required),
      fk_rol: new FormControl<number>(1, Validators.required)
    }, {
      validators: this.passwordsIguales('contrasena', 'contrasena_confirmation')
    });
  }

  ngOnInit() { }

  get f() {
    return this.usuarioForm.controls;
  }

  onSubmit() {
    if (this.usuarioForm.invalid) {
      this.usuarioForm.markAllAsTouched();
      return;
    }
    // aquí enviarías this.usuarioForm.value al backend
    //console.log('Formulario válido:', this.usuarioForm.getRawValue());
    this.usuarioService.create(this.usuarioForm.getRawValue())
      .subscribe({
        next: (resp) => { this.showSuccess(resp.mensaje); },
        error: (err) => { this.showWarning(err.mensaje); }
      });
  }

  /* passwordsIguales(pass: string, confirm: string) {
     return (formGroup: AbstractControl) => {
       const passControl = formGroup.get(pass);
       const confirmControl = formGroup.get(confirm);
 
       if (passControl && confirmControl) {
         const error = passControl.value === confirmControl.value ? null : { passwordMismatch: true };
         confirmControl.setErrors(error);
         if (error === null) {
           confirmControl.updateValueAndValidity({ onlySelf: true });
         }
       }
     };
   }
 */

  passwordsIguales(pass: string, confirm: string) {
    return (formGroup: AbstractControl) => {
      const passControl = formGroup.get(pass);
      const confirmControl = formGroup.get(confirm);

      if (passControl && confirmControl) {
        const passValue = passControl.value;
        const confirmValue = confirmControl.value;

        if (passValue !== confirmValue && confirmControl?.value) {
          confirmControl.setErrors({ ...confirmControl.errors, passwordMismatch: true });
        } else {
          // Si no hay otros errores, elimina solo el de passwordMismatch
          if (confirmControl.errors) {
            const { passwordMismatch, ...others } = confirmControl.errors;
            confirmControl.setErrors(Object.keys(others).length > 0 ? others : null);
          }
        }
      }
    };
  }
  showSuccess(msg: string): void {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg });
  }
  showWarning(msg: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Nota!!', detail: msg });
  }
}